import { type FC, type ReactNode } from "react";
import classNames from "classnames";
import { TableSortLabel as MuiTableSortLabel, type TableSortLabelProps as MuiTableSortLabelProps } from "@mui/material";
import { Icon } from "../icon/Icon";
import { IconType } from "../icon/IconType";
import { IconSize } from "../icon/IconSize";
import { makeStyles } from "@mui/styles";
import { C_ON_SURFACE, C_PRIMARY, C_PRIMARY_HOVER } from "../icon/Colors";

export { Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";

type HeaderCellTitleProps = JSX.IntrinsicElements["div"] & {
  header: ReactNode;
  subheader?: ReactNode;
  children?: never;
  subHeaderClass?: string;
};
export const HeaderCellTitle: FC<HeaderCellTitleProps> = (props) => {
  const { header, subheader, className, subHeaderClass, ...rest } = props;
  const cls = classNames(className, "d-flex flex-direction-column f-bold");
  const subHeaderCls = classNames(subHeaderClass, "f-normal f-label-color");
  return (
    <div className={cls} {...rest}>
      {header}
      {subheader && <div className={subHeaderCls}>{subheader}</div>}
    </div>
  );
};

const useStyles = makeStyles({
  root: {
    color: C_ON_SURFACE,
    "&:hover": {
      color: C_PRIMARY,
      "& $icon": {
        opacity: 1,
      },
    },
    alignItems: "flex-start",
    "&$active": {
      color: C_PRIMARY,
      "&:hover": {
        color: C_PRIMARY_HOVER,
      },
    },
  },
  active: {},
  icon: {
    opacity: 1,
    fontSize: "10px",
    marginRight: "8px",
    marginLeft: 0,
    lineHeight: "18px",
    color: "inherit !important",
  },
  iconDirectionDesc: {},
  iconDirectionAsc: {},
});

export const TableSortLabel = (props: MuiTableSortLabelProps) => {
  const classes = useStyles(props);
  return <MuiTableSortLabel {...props} classes={classes} IconComponent={renderIcon} />;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const renderIcon = (props: any) => <Icon type={IconType.ArrowDown} size={IconSize.FONT_10} {...props} />;
